module.exports = __webpack_public_path__ + "static/media/ic_expand_more.32585289.svg";